const usable = (value: unknown): value is string =>
    typeof value === 'string'
    && !!value.trim()
    && !/insufficient current intelligence|world governance indicators|\bWGI\b|^N\/A$/i.test(value);

export function getLeadershipStatus(overview: any): string {
    if (usable(overview?.currentStatus)) return overview.currentStatus.trim();
    if (usable(overview?.headOfState)) return `Current head of state: ${overview.headOfState.trim()}`;
    return 'Leadership status not verified.';
}
